//-----------------------------------------------
// Lazy Animated GIFs
//
// theme-functions.php swaps large GIFs' src onto data-lazy-src and leaves a
// transparent placeholder. This fetches the real GIF via IntersectionObserver
// as the block approaches the viewport, so a below-the-fold GIF never competes
// with the hero / LCP during initial load. The rootMargin is deliberately
// generous so the GIF is downloaded well before it scrolls into view — on a
// normal connection the swap is invisible.
//-----------------------------------------------

(function () {
	var imgs = document.querySelectorAll("img.js-lazy-gif[data-lazy-src]");
	if (!imgs.length) return;

	var load = function (img) {
		if (img.dataset.lazyLoaded) return;
		img.dataset.lazyLoaded = "true";
		if (img.dataset.lazySrcset) {
			img.srcset = img.dataset.lazySrcset;
		}
		img.src = img.dataset.lazySrc;
	};

	if (!("IntersectionObserver" in window)) {
		Array.prototype.forEach.call(imgs, load);
		return;
	}

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				load(entry.target);
			});
		},
		{ rootMargin: "1200px 0px" },
	);

	Array.prototype.forEach.call(imgs, function (img) {
		observer.observe(img);
	});
})();
